import React from "react";
import { Chip } from "@mui/material";
import {
  PASTEL_CHIP_BASE_SX,
  stageChipSx,
} from "features/integrationsBeta/platformEnumUi";

type Props = {
  stage: string;
  label: string;
  size?: "small" | "medium";
};

export default function StageChip({ stage, label, size = "small" }: Props) {
  return (
    <Chip
      label={label}
      size={size}
      sx={{
        ...PASTEL_CHIP_BASE_SX,
        minWidth: 100,
        ...(stageChipSx(stage) as object),
      }}
    />
  );
}
